'use strict';

import { Text3D } from './Text3D';
import { Arrow } from './Arrow';
import { Group } from 'three';
import { isMobile, projectMode, threeJsVariables } from '../../../settings';
import { Box } from './Box';
import { Sphere } from './Sphere';
import { Orbit360Viewer } from '../../components/publicLayers/Orbit360Viewer';
import { addPoiToIntersection } from '../../poi/poiCss';
import { PointView } from './PointView';
import { PointViewManager } from '../../components/pointViewManager/PointViewManager';

export class Objects {
  static elements = [];
  static cylinderCSSLabels = [];
  static scope = null;
  static tl = null;
  static useLabelsFromBundle = false;

  constructor (config) {
    this.config = config;
    this.group = new Group();
    this.group.name = 'Additional objects';
    threeJsVariables.scene.add(this.group);
    Objects.scope = this;
  }

  add(textureLoader) {
    const needsPointViewManager = this.config.find(el => el.type === 'PointView');
    let pointViewManager = null;
    if (needsPointViewManager && !projectMode.AirMode.active) {
      pointViewManager = new PointViewManager();
    }
    
    this.config.forEach(data => {
      let scope = null;
      switch (data.type) {
        case 'PointView':
          if (!projectMode.AirMode.active) {
            scope = new PointView(data);
            const label = scope.createLabel();
            pointViewManager.add(scope);
            // addPoiToIntersection(label);
            this.group.add(label);
          }
          break;
        case 'Text':
          scope = new Text3D(data);
          this.group.add(scope);
          break;
        case 'Arrow':
          scope = new Arrow(data,textureLoader);
          this.group.add(scope.mesh);
          break;
        case 'Box':
          scope = new Box(data,textureLoader);
          this.group.add(scope.mesh);
          break;
        case 'Sphere':
          scope = new Sphere(data,textureLoader);
          this.group.add(scope.mesh);
          break;
        case 'CSSLabel':
            if (data.data.url) {
              Objects.useLabelsFromBundle = true;
              scope = new Orbit360Viewer(data.data);
              scope.label.position.fromArray(data.position);
              scope.label.name = data.id;
              addPoiToIntersection(scope.label);
              this.group.add(scope.label);
            }
          break;
        case 'CylinderCSSLabel':
          // Allow only for web/desktop. Waiting for mobile fix.
          if (data.data.url && !isMobile) {
            Objects.cylinderCSSLabels.push(data);
          }
          break;
      }

      if (scope) {
        Objects.elements.push(scope);
      }
    });
    
  }

  static visibilityToggle(state) {
    if (Objects.scope) {
      Objects.elements.forEach(scope => scope.objectType !== 'CSSLabel' && scope.visibilityToggle(state));
    }
  }

  static visibilityCSSLabels(state) {
    if (threeJsVariables.cssLabelManager.isBlocked('objectCssLabels'))
      return;
    
    if (Objects.scope) {
      const cssScopes = Objects.elements.filter(scope => scope.objectType === 'CSSLabel');
      cssScopes.forEach(scope => scope.visibilityToggle(state));
    }
  }

  static translate() {
    if (Objects.scope) {
      Objects.elements.forEach(scope => {
        if (scope.translateText) {
          scope.translateText();
        }
      });
    }
  }

}
